import { createSelector } from 'reselect';
import { carouselOnPLPNthCategorySelector } from 'selectors/testTarget/offers/carouselOnPLPNthCategory/carouselOnPLPNthCategorySelector';

const enabledSelector = createSelector(carouselOnPLPNthCategorySelector, carouselOnPLPNthCategory => carouselOnPLPNthCategory.enabled);

export { enabledSelector };
